var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFineArtsPaintbrush(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#FFFFFF;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:13;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:6;stroke-miterlimit:10;}\r\n\t.st6{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000085250769749564394010000013966411904037341572_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M540,61.6L281.2,584l128.7,168.3c15.7,20.5,24.2,45.7,24.2,71.5v193.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M540,61.6L798.8,584L670.1,752.3c-15.7,20.5-24.2,45.7-24.2,71.5v193.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 540,
    y1: 24,
    x2: 540,
    y2: 593.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 581.6,
    r: 42.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 365.9,
    y1: 899.2,
    x2: 711.8,
    y2: 899.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.3,
    y: 899.2,
    width: 150.6,
    height: 117.6
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M437.8,551.4C654.4,343.7,1032.4,14.5,1053,36c20.6,21.5-324,385.5-540.5,593.3S245.3,852.2,224.6,830.7 S221.3,759.1,437.8,551.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.8,946c29.3-32.2,31-78.4,3.8-103c-27.2-24.7-88.9-4.6-104,36.3c-38,102.9-78.6,137.2-78.6,137.2 S175.6,978.3,204.8,946z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 389.6,
    y1: 755.8,
    x2: 305.5,
    y2: 668.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 416.5,
    y1: 730,
    x2: 332.4,
    y2: 642.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M483.2,770.9c-72.5,0-150.7-24.5-209.1-65.5c-64.5-45.2-100-106-100-171c0-35.7,7.1-69.3,21.2-100 c13.3-29,32.6-54.9,57.4-76.8c48.4-42.9,114.5-67.9,186.2-70.5c3.9-0.1,8-0.2,12.1-0.2c59,0,133.1,15,193.4,39 c67.6,27,109.8,61,118.8,95.8c4.5,17.2,0.7,34.8-11.3,52.2c-13.6,19.8-37.9,39.4-72,58.5c-29.6,16.5-44.6,33.9-44.5,51.8 c0,26.1,31.6,43.5,43.5,50.1c1.3,0.7,2.7,1.5,3.1,1.8c22.9,16.7,32.7,37.6,26.8,57.5c-5.6,18.7-24.7,35.5-55.2,48.4 c-37,15.7-88.9,25.3-154.4,28.5C493.8,770.8,488.5,770.9,483.2,770.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.9,291.9c58.4,0,131.8,14.8,191.5,38.7c31.2,12.5,58.1,27.2,77.8,42.5c20.9,16.3,33.7,33.1,38.1,50 c4.2,16,0.7,31.7-10.6,48.1c-13.2,19.1-36.9,38.3-70.3,57c-31.7,17.7-47.1,36.1-47.1,56.1c0,29,33.5,47.5,46,54.5 c1,0.5,2.2,1.2,2.6,1.5c21,15.3,30.1,34.3,24.8,52c-5.1,17.2-23.2,32.9-52.3,45.2c-36.4,15.5-87.8,24.9-152.7,28.1 c-5.1,0.2-10.3,0.4-15.5,0.4c-35.1,0-72.5-5.8-107.9-16.9c-35.8-11.1-69.8-27.6-98.3-47.7c-30.3-21.2-54.1-45.9-70.8-73.3 c-17.9-29.3-27-60.8-27-93.7c0-35,7-67.9,20.8-97.9c13.1-28.4,31.9-53.7,56.1-75.1c47.5-42.1,112.5-66.7,183-69.3 C442.9,292,446.9,291.9,450.9,291.9L450.9,291.9 M450.9,281.9c-4.2,0-8.2,0.1-12.2,0.2c-145.4,5.3-269.6,102-269.6,252.2 c0,144.9,167.6,241.5,314.1,241.5c5.4,0,10.7-0.1,16.1-0.4c228.5-11.3,247.5-98.3,185.5-143.4c-6.1-4.4-95.3-43.4-2.5-95.2 C918.1,405.2,622.7,281.9,450.9,281.9L450.9,281.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 274.2,
    cy: 546.8,
    rx: 46.5,
    ry: 46.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M274.2,500.8c25.4,0,46,20.6,46,46s-20.6,46-46,46s-46-20.6-46-46S248.9,500.8,274.2,500.8 M274.2,499.8 c-26,0-47,21-47,47s21,47,47,47s47-21,47-47C321.2,520.8,300.2,499.8,274.2,499.8L274.2,499.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.1,
    cy: 420.7,
    rx: 46.5,
    ry: 46.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M310.1,374.6c25.4,0,46,20.6,46,46s-20.6,46-46,46s-46-20.6-46-46S284.7,374.6,310.1,374.6 M310.1,373.6 c-26,0-47,21-47,47c0,26,21,47,47,47c26,0,47-21,47-47C357.1,394.7,336,373.6,310.1,373.6L310.1,373.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435,410.2c-25.6,0-46.5-20.9-46.5-46.5c0-25.6,20.9-46.5,46.5-46.5c25.6,0,46.5,20.9,46.5,46.5 C481.5,389.4,460.6,410.2,435,410.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M435,317.8c25.4,0,46,20.6,46,46s-20.6,46-46,46s-46-20.6-46-46S409.6,317.8,435,317.8 M435,316.8 c-26,0-47,21-47,47c0,26,21,47,47,47c26,0,47-21,47-47S460.9,316.8,435,316.8L435,316.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M574.7,432.6c-25.6,0-46.5-20.8-46.5-46.5c0-25.6,20.8-46.5,46.5-46.5c25.6,0,46.5,20.9,46.5,46.5 C621.2,411.7,600.3,432.6,574.7,432.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M574.7,340.1c25.4,0,46,20.6,46,46s-20.6,46-46,46s-46-20.6-46-46S549.4,340.1,574.7,340.1 M574.7,339.1 c-26,0-47,21-47,47s21,47,47,47s47-21,47-47S600.7,339.1,574.7,339.1L574.7,339.1z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "688.4,939.2 284.3,939.2 465.4,561.4  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 703.9,
    cy: 398.1,
    r: 163.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFineArtsPaintbrush);
export default __webpack_public_path__ + "static/media/Fine-Arts-Paintbrush.c4f58bc319fb63b9d71c2f5c39549031.svg";
export { ForwardRef as ReactComponent };